import React, { Component } from 'react';
import { checkTranslation } from '../utils/useful';
import ReactHtmlParser from 'react-html-parser';

class HelpButton extends Component {
    state = {}

    render() {
        return (
            <div className="tooltip-container flexcc" style={{ position: 'relative', cursor: 'pointer' }}>
                <div className="flexcc" style={{ border: '1px solid rgb(53,165,235)', borderRadius: '100%', width: 16, height: 16 }}>
                    <div className="flexcc" style={{ overflow: 'hidden' }}>
                        <p style={{ fontSize: 12, textAlign: 'center', color: 'rgb(53,165,235)' }}>i</p>
                    </div>
                </div>

                <div className="tooltip-hover" >
                    <div style={{ width: "10px", height: "10px", position: 'absolute', transform: 'rotate(45deg)', bottom: '20px', left: '33%', background: '#202020' }}>                          </div>
                    <div className='back-blur' style={{ zIndex: 999, position: 'absolute', bottom: '25px', left: '-26px', background: '#202020ee', padding: '12px 12px', boxShadow: '0px 0px 50px #10101020', borderRadius: '10px', color: '#777', fontSize: '14px', width: '180px', }}>
                        <p style={{ fontSize: 12, color: '#eee', lineHeight: 1.7 }}>{checkTranslation(ReactHtmlParser(this.props.data))}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default HelpButton;